import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { removeGroup, fetchGroups, updateGroup } from './Groups.actions';
import { Action } from '@reduxjs/toolkit';
import {
  addGroups,
  deleteGroup,
  setIsFetching,
  setListGroups,
  setPage,
  setTotal,
  updateGroupById,
  setActiveGroup,
} from './Groups.slice';
import { RootState } from '../../app/store';
import { Unwrap } from '../../domains/app';
import GroupService from '../../service/Groups.service';
import { Group } from './groups';

function* fetchGroupsSaga(action: Action) {
  try {
    yield put(setIsFetching(true));
    if (fetchGroups.match(action)) {
      const refreshList = action.payload;
      if (refreshList) {
        yield put(setPage(0));
      }
      const page: number = yield select(
        (state: RootState) => state.groups.page,
      );
      const pageSize: number = yield select(
        (state: RootState) => state.groups.pageSize,
      );
      const search: string = yield select(
        (state: RootState) => state.groups.search,
      );
      const spaceId: string = yield select(
        (state: RootState) => state.app.selectedAccount?.id,
      );

      const res: Unwrap<ReturnType<
        typeof GroupService.fetchListGroups
      >> = yield call(
        GroupService.fetchListGroups,
        spaceId,
        pageSize,
        page,
        search,
      );
      if (refreshList) {
        yield put(setListGroups([]));
      }
      yield put(addGroups(res.items));
      yield put(setTotal(res.total));
      if (res.items.length) {
        yield put(setActiveGroup(res.items[0]));
      }
      yield put(setPage(page + 1));
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setIsFetching(false));
  }
}

function* updateGroupSaga(action: Action) {
  try {
    if (updateGroup.match(action)) {
      const group: Group = action.payload as Group;
      const activeGroup: Group | undefined = yield select(
        (state: RootState) => state.groups.activeGroup,
      );
      if (activeGroup && group.id) {
        const res: Unwrap<ReturnType<
          typeof GroupService.updateGroup
        >> = yield call(GroupService.updateGroup, group);

        yield put(updateGroupById(res));
        yield put(setActiveGroup(res));
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
  }
}

function* deleteGroupSaga(action: Action) {
  try {
    if (removeGroup.match(action)) {
      const id = action.payload;

      yield call(GroupService.deleteGroup, id);

      yield put(deleteGroup(id));

      const activeGroup: Group | undefined = yield select(
        (state: RootState) => state.groups.activeGroup,
      );
      if (activeGroup?.id === id) {
        yield put(setActiveGroup());
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([
    takeLatest(fetchGroups.toString(), fetchGroupsSaga),
    takeLatest(updateGroup.toString(), updateGroupSaga),
    takeLatest(removeGroup.toString(), deleteGroupSaga),
  ]);
}
